// App build metadata — bump VERSION when shipping a new release.
// LAST_UPDATE is a static ISO string so the footer doesn't change at every page render.
export const APP_VERSION = "1.3.0";
export const APP_LAST_UPDATE = "2026-02-13T09:15:00+01:00";

export function formatBuildDate(iso = APP_LAST_UPDATE) {
  const d = new Date(iso);
  return d.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
